export default function About() {
  return (
    <section id="about" className="about">
      <h2>About Me</h2>
      <p>
        I am Dr. Nirajan, a dedicated physician with over 10 years of experience 
        in patient care. My goal is to provide professional, compassionate, 
        and personalized healthcare to every patient.
      </p>

      <style>{`
        .about {
          padding: 80px 20px;
          text-align: center;
          background: white;
        }
        .about h2 {
          font-size: 36px;
          color: #5D3FD3;
          margin-bottom: 20px;
        }
        .about p {
          font-size: 18px;
          color: #333;
          max-width: 700px;
          margin: auto;
          line-height: 1.6;
        }
      `}</style>
    </section>
  );
}
